module.exports = __webpack_public_path__ + "img/next-steps-1.d0c303cd.png";